import { render, staticRenderFns } from "./InformationTrainingCourse.vue?vue&type=template&id=3609f588&scoped=true"
import script from "./InformationTrainingCourse.vue?vue&type=script&lang=js"
export * from "./InformationTrainingCourse.vue?vue&type=script&lang=js"
import style0 from "./InformationTrainingCourse.vue?vue&type=style&index=0&id=3609f588&prod&scoped=true&lang=css"
import style1 from "./InformationTrainingCourse.vue?vue&type=style&index=1&id=3609f588&prod&lang=css"
import style2 from "./InformationTrainingCourse.vue?vue&type=style&index=2&id=3609f588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3609f588",
  null
  
)

export default component.exports